
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.53 24.738"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-64)","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 7048","d":"M81.074 0H65.455A1.457 1.457 0 0064 1.455v21.828a1.457 1.457 0 001.455 1.455h15.619a1.457 1.457 0 001.455-1.455V1.455A1.457 1.457 0 0081.074 0zM70.16 20.47h-2.328a.728.728 0 110-1.455h2.328a.728.728 0 110 1.455zm0-3.1h-2.328a.728.728 0 110-1.455h2.328a.728.728 0 010 1.455zm0-3.1h-2.328a.728.728 0 110-1.455h2.328a.728.728 0 010 1.455zm.171-3.007h-2.67a.66.66 0 01-.556-.728.66.66 0 01.556-.728h2.671a.66.66 0 01.556.728.66.66 0 01-.556.719zm9.094 8.877a.728.728 0 01-1 .673l-2.441-1-2.441 1a.728.728 0 01-1-.674c0-7.02-.006-6.6.013-6.7a3.444 3.444 0 116.875-.286zM78.7 8.052H67.832a.728.728 0 110-1.455H78.7a.728.728 0 110 1.455zm0-3.1H67.832a.728.728 0 110-1.455H78.7a.728.728 0 110 1.455z"}}),_c('circle',{attrs:{"data-name":"Ellipse 5","cx":"2","cy":"2","r":"2","transform":"translate(74 10.989)"}}),_c('path',{attrs:{"data-name":"Path 7049","d":"M73.992 15.954v3.089l1.713-.7a.728.728 0 01.551 0l1.713.7v-3.092a3.431 3.431 0 01-3.977.003z"}})])])
          )
        }
      }
    